'use strict';exports.__esModule = true;var _constants = require('../constants');
var _modifyImageLink = require('./modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _userPlaceholder = require('../../static/images/user-placeholder.svg');var _userPlaceholder2 = _interopRequireDefault(_userPlaceholder);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getUserLogoUrl = function getUserLogoUrl(imageUrl) {var modificationType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.imageModifierTypes.LOGO;return (
    imageUrl ? (0, _modifyImageLink2.default)(imageUrl, modificationType) : _userPlaceholder2.default);};exports.default =

getUserLogoUrl;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/getUserLogoUrl.js
// module id = 241
// module chunks = 0